export enum StepStatus {
  Success = 'success',
  Pending = 'info', // MUI 'default' color represents a pending state
  Warning = 'warning',
  Error = 'error',
}

export enum RefundStatus {
  ResourceApprovalCanceled = 'resource_approval_canceled',
  ResourceApprovalRevisionRequired = 'resource_approval_revision_required',
  ResourceApprovalPendingApproval = 'resource_approval_pending_approval',
  ResourceApprovalRejected = 'resource_approval_rejected',
  ResourceApprovalNotApproved = 'resource_approval_not_approved',
  ResourceApprovalApproved = 'resource_approval_approved',
  RefundRequestCanceled = 'refund_request_canceled',
  RefundRequestPendingApproval = 'refund_request_pending_approval',
  RefundRequestRevisionRequired = 'refund_request_revision_required',
  RefundRequestRejected = 'refund_request_rejected',
  RefundRequestApproved = 'refund_request_approved',
  RefundRequestPaid = 'refund_request_paid',
}
